// Mock data for gas smart meters
export const mockSmartGasMeters = [
  {
    deviceId: "GAS001",
    location: "Building A, Floor 1",
    status: "Healthy",
    batteryLevel: 87,
    signalStrength: 92,
    lastCommunication: "2024-12-15T14:30:00Z",
    firmwareVersion: "v3.5.2",
    readings: {
      pressure: 220,
      flowRate: 5.5,
      temperature: 22.2,
      methaneContent: 92.2,
      totalVolume: 2567.9
    },
    maintenanceStatus: {
      lastMaintenance: "2024-09-10",
      nextScheduled: "2026-01-10", 
      alerts: []
    }
  },
  {
    deviceId: "GAS002",
    location: "Building A, Floor 2",
    status: "Warning",
    batteryLevel: 42,
    signalStrength: 78,
    lastCommunication: "2024-12-15T13:45:00Z",
    firmwareVersion: "v3.5.1",
    readings: {
      pressure: 215,
      flowRate: 8.7,
      temperature: 23.3,
      methaneContent: 88.8,
      totalVolume: 1892.5
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-15",
      nextScheduled: "2026-02-15", 
      alerts: ["Battery replacement needed"]
    }
  },
  {
    deviceId: "GAS003",
    location: "Building B, Floor 1",
    status: "Critical",
    batteryLevel: 12,
    signalStrength: 31,
    lastCommunication: "2024-12-14T09:15:00Z",
    firmwareVersion: "v3.4.9",
    readings: {
      pressure: 190,
      flowRate: 2.8,
      temperature: 24.1,
      methaneContent: 85.5,
      totalVolume: 1938.7
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-20",
      nextScheduled: "2026-01-20", 
      alerts: ["Communication failure", "Battery critical", "Maintenance overdue"]
    }
  },
  {
    deviceId: "GAS004",
    location: "Building B, Floor 2",
    status: "Healthy",
    batteryLevel: 95,
    signalStrength: 89,
    lastCommunication: "2024-12-15T14:25:00Z",
    firmwareVersion: "v3.5.2",
    readings: {
      pressure: 225,
      flowRate: 6.4,
      temperature: 21.5,
      methaneContent: 93.0,
      totalVolume: 2245.8
    },
    maintenanceStatus: {
      lastMaintenance: "2024-10-05",
      nextScheduled: "2026-02-05", 
      alerts: []
    }
  },
  {
    deviceId: "GAS005",
    location: "Building C, Floor 1",
    status: "Warning",
    batteryLevel: 56,
    signalStrength: 68,
    lastCommunication: "2024-12-15T11:05:00Z",
    firmwareVersion: "v3.5.0",
    readings: {
      pressure: 210,
      flowRate: 7.9,
      temperature: 22.8,
      methaneContent: 90.5,
      totalVolume: 2123.6
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-25",
      nextScheduled: "2026-02-25", 
      alerts: ["Firmware update required"]
    }
  },
  {
    deviceId: "sm-10023",
    location: "Building D, Floor 1",
    status: "Healthy",
    batteryLevel: 88,
    signalStrength: 91,
    lastCommunication: "2024-12-15T15:45:00Z",
    firmwareVersion: "v3.5.2",
    readings: {
      pressure: 218,
      flowRate: 5.2,
      temperature: 21.8,
      methaneContent: 91.5,
      totalVolume: 2345.7
    },
    maintenanceStatus: {
      lastMaintenance: "2024-10-15",
      nextScheduled: "2026-02-15", 
      alerts: []
    }
  },
  {
    deviceId: "sm-10045",
    location: "Building E, Floor 2",
    status: "Warning",
    batteryLevel: 38,
    signalStrength: 64,
    lastCommunication: "2024-12-15T12:15:00Z",
    firmwareVersion: "v3.5.0",
    readings: {
      pressure: 205,
      flowRate: 4.8,
      temperature: 23.5,
      methaneContent: 87.2,
      totalVolume: 2156.3
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-05",
      nextScheduled: "2026-01-05", 
      alerts: ["Unusual gas flow pattern"]
    }
  }
];
